import { CountUp } from 'countup.js';

export default class CountUpInstance {
    constructor() {
        this.countUp = null;
    }

    init(element, end, options) {
        this.countUp = new CountUp(element, end, options);
    }

    start() {
        this.countUp.start();
    }
}
